"use strict";

var _slicedToArray = require("/builds/gitlab/eductx/eductx-react/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("./utils");

var cid_1 = require("multiformats/cid");

function fromSplit(split) {
  var _split = _slicedToArray(split, 3),
      protectedHeader = _split[0],
      payload = _split[1],
      signature = _split[2];

  return {
    payload: payload,
    signatures: [{
      protected: protectedHeader,
      signature: signature
    }],
    link: cid_1.CID.decode(utils_1.fromBase64url(payload))
  };
}

function encodeSignature(signature) {
  var encoded = {
    signature: utils_1.fromBase64url(signature.signature)
  };
  if (signature.header) encoded.header = signature.header;
  if (signature.protected) encoded.protected = utils_1.fromBase64url(signature.protected);
  return encoded;
}

function encode(jws) {
  var payload = utils_1.fromBase64url(jws.payload);

  try {
    cid_1.CID.decode(payload);
  } catch (e) {
    throw new Error('Not a valid DagJWS');
  }

  var encodedJws = {
    payload: payload,
    signatures: jws.signatures.map(encodeSignature)
  };
  return encodedJws;
}

function decodeSignature(encoded) {
  var sign = {
    signature: utils_1.toBase64url(encoded.signature)
  };
  if (encoded.header) sign.header = encoded.header;
  if (encoded.protected) sign.protected = utils_1.toBase64url(encoded.protected);
  return sign;
}

function decode(encoded) {
  var decoded = {
    payload: utils_1.toBase64url(encoded.payload),
    signatures: encoded.signatures.map(decodeSignature)
  };
  decoded.link = cid_1.CID.decode(new Uint8Array(encoded.payload));
  return decoded;
}

exports.default = {
  fromSplit: fromSplit,
  encode: encode,
  decode: decode
};